export enum ESignatureFlow {
    MOBILE = 'urn:eparaksts:authentication:flow:mobileid',
    CARD = 'urn:eparaksts:authentication:flow:sc_plugin',
}
